export default function (collection, data = {}, count = 10, opts = {}) {
  const skeletons = []

  Array(count).fill().forEach((_, i) => {
    const obj = { id: (i + 1) * -1 }
    Object.assign(obj, data)

    skeletons.push(obj)
  })

  if (opts.add) {
    collection.add(skeletons, opts)
  } else {
    collection.set(skeletons, opts)
  }
}
